import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AddonName, PaymentDetails, PurchasableAddonName } from '@sona/shared-model-common';

import { StripePrice } from '../models/stripe-price';

import type Stripe from 'stripe';

@Injectable({
    providedIn: 'root'
})
export class PaymentsApi {
    private readonly _http = inject(HttpClient);

    createCustomerSession() {
        return this._http.post<Stripe.CustomerSession>('/api/payments/sessions/customer', {});
    }

    createBillingPortalSession() {
        return this._http.post<{ url: string; }>('/api/payments/sessions/billing-portal', {});
    }

    createCheckoutSession(addonName: AddonName | null | undefined, previousUrl?: string) {
        if (!addonName) {
            throw new Error('addonName is required to create a checkout session.');
        }

        return this._http.post<{ url: string }>('/api/payments/sessions/checkout', { addonName, previousUrl });
    }

    getPaymentDetails(sessionId: string | null | undefined) {
        if (!sessionId) {
            throw new Error('sessionId is required to get payment details.');
        }

        return this._http.get<PaymentDetails>(`/api/payments/payment-details/${sessionId}`);
    }

    getPrice(addonName: AddonName | null | undefined) {
        if (!addonName) {
            throw new Error('addonName is required to get price details.');
        }

        return this._http.get<StripePrice>(`/api/payments/addons/${addonName}/prices/purchasable`);
    }

    endTrial() {
        return this._http.post('/api/payments/subscriptions/end-trial', {});
    }
}
